import React from 'react';
import { Route } from 'react-router-dom';

class ModelSelection extends React.Component {
  render() {
    let models = this.props.models.map(o => o.title).join(', ');

    return (
      <Route render={({ history}) => (
        <button className="modify-selection" onClick={() => { this.props.updateState({phase: this.props.phase}); history.push(this.props.path) }}>
          {this.props.label + ": " + models}
        </button>
      )} />
    );
  }
}

export default ModelSelection;
